import { useColor } from "react-color-palette";
import { useController } from "react-hook-form";
import { ColorPicker } from "src/components/ColorPicker";

export interface ColourPickerStepProps {
	name: string;
	label?: string;
	className?: string;
}

const ColourPickerStep = ({
	name,
	label,
	...restProps
}: ColourPickerStepProps) => {
	const {
		field: { value, onChange }
	} = useController({ name });

	const [color] = useColor(value ?? "");

	return (
		<div className="max-w-[480px]" {...restProps}>
			{label ? (
				<label className="block text-sm font-medium text-zinc-600 mb-1.5">
					{label}
				</label>
			) : (
				<span className="sr-only">Pick a colour or enter a hex code</span>
			)}

			<ColorPicker color={color} onChange={({ hex }) => onChange(hex)} />
		</div>
	);
};

export default ColourPickerStep;
